import {Injectable, NgZone} from '@angular/core';
import {BehaviorSubject} from "rxjs";

@Injectable({
  providedIn: 'root',
})
export class UtilService {
  private onlineStatus = new BehaviorSubject<boolean>(navigator.onLine);
  onlineStatus$ = this.onlineStatus.asObservable();

  constructor(private zone: NgZone) {
    // Online event
    window.addEventListener('online', () => {
      console.log('✅ Online event triggered'); // <-- added log
      this.zone.run(() => this.onlineStatus.next(true));
    });

    // Offline event
    window.addEventListener('offline', () => {
      console.log('❌ Offline event triggered'); // <-- added log
      this.zone.run(() => this.onlineStatus.next(false));
    });
  }

  private imageFileTypes = [

      'image/apng',
    'image/bmp',
    'image/gif',
    'image/jpeg',
    'image/png',
    'image/svg+xml',
    'application/pdf',
    'application/zip',
    'video/mp4',
    'video/mp4',
    'video/mpeg',
    'video/mpeg',
  ];

  validateFile(file: File): boolean {
    return this.imageFileTypes.includes(file.type);
  }




}
